import React from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';

const MotherAliveStep: React.FC<StepComponentProps> = ({
                                                         formData,
                                                         updateFormData,
                                                         onNext,
                                                         onPrevious,
                                                         canGoBack,
                                                         canGoNext,
                                                         patientCaseType,
                                                         journey,
                                                       }) => {
  const handleSubmit = (event: any, values: any) => {
    onNext();
  };

  const handleMotherAliveChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value === 'true';
    updateFormData({motherAlive: value});
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="text-danger mb-4">Is Mother Alive?</h6>
        <AvForm onValidSubmit={handleSubmit}>
          <AvRadioGroup name="motherAlive" required value={formData.motherAlive?.toString()}>
            <Row>
              <Col md="6">
                <Label className="radio-button-label">
                  <AvRadio
                    name="motherAlive"
                    value="true"
                    onChange={handleMotherAliveChange}
                    className="radio-button-input"
                  />
                  Yes
                </Label>
              </Col>
              <Col md="6">
                <Label className="radio-button-label">
                  <AvRadio
                    name="motherAlive"
                    value="false"
                    onChange={handleMotherAliveChange}
                    className="radio-button-input"
                  />
                  No
                </Label>
              </Col>
            </Row>
          </AvRadioGroup>

          <FollowupButtons
            currentStep={4}
            totalSteps={10}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default MotherAliveStep;
